import React from 'react';
import marked from 'marked';

const FAQ = ({ data }) => {
  
  const { faq_content = "", faq_heading = "" } = data;

  return (
    <>
      {faq_content && faq_heading ?
        <div className="seoFaqWrap" itemScope itemType="https://schema.org/FAQPage">
          <h2 className="faqHeading">{faq_heading}</h2>
          {faq_content.map((item, index) => {
            return (
              <div className="seoFaqItem" key={index + 'busFAQHome'} itemProp="mainEntity" itemScope itemType="https://schema.org/Question">
                <div className="seoFaqItem"
                  dangerouslySetInnerHTML={{ __html: marked(`<strong>Q.</strong> ${item.q}`), }}
                  itemProp="name">
                </div>
                <div itemProp="acceptedAnswer" itemScope itemType="https://schema.org/Answer">
                  <div dangerouslySetInnerHTML={{ __html: marked(`A. ${item.a}`), }}
                    itemProp="text">
                  </div>
                </div>
              </div>
            );
          })}
        </div> : <></>}
    </>
  );
};

export default FAQ;
